import React, { useState, useEffect } from 'react';

import {
    Heading,
    Container,
    Row,
    Col,
    Accordion,
    className,
    isMobile,
} from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';

import PricingTable from '../PricingTable';
import TabComponent from '../TabComponent';

import style from './style.module.scss';
import textStyle from 'aplazame-design-system/src/scss/text.module.scss';

export default function PricingTabsSection({
    title,
    titleTag,
    pricingDetail,
    button,
}) {
    const [allShown, setAllShown] = useState(!isMobile());
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        const changeAllShown = () => {
            setAllShown(!isMobile());
        };

        window.addEventListener('resize', changeAllShown);

        const onHashChangeListener = () => {
            const hash = window.location.hash
                ? window.location.hash.replace('#', '')
                : '';
            if (hash) {
                const i = pricingDetail.findIndex((item) => item.slug === hash);

                if (i >= 0) {
                    setActiveTab(i);
                }
            }
        };

        onHashChangeListener();
        window.addEventListener('hashchange', onHashChangeListener);

        return () => {
            window.removeEventListener('resize', changeAllShown);
            window.removeEventListener('hashchange', onHashChangeListener);
        };
    }, [setAllShown, setActiveTab, pricingDetail]);

    return (
        <section>
            <Container pt={{ xs: 10, lg: 10 }} pb={{ xs: 5 }}>
                <Row className="text-center">
                    <Col
                        col={{ lg: 10 }}
                        offset={{ lg: 1 }}
                        className="d-none d-lg-block"
                    >
                        <Heading
                            tag={titleTag}
                            className={`h2 ${textStyle.gradual} mb-10 ${style.heading}`}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            {title}
                        </Heading>
                    </Col>
                </Row>
                {pricingDetail.map((pricingItem, i) => (
                    <div
                        key={i}
                        data-anchor={pricingItem.slug}
                        data-disable-reset="true"
                    />
                ))}
                <Row>
                    <Col>
                        <TabComponent
                            className={`d-none d-lg-flex ${style.tab}`}
                            linkClassName={style['tab__link']}
                            activeClassName={style['tab__link--active']}
                            items={pricingDetail.map((pricingItem, i) => ({
                                active: activeTab === i,
                                title: pricingItem.title,
                                href: `#${pricingItem.slug}`,
                            }))}
                        />
                    </Col>
                </Row>
                <Row>
                    {pricingDetail.map((pricingItem, i) => (
                        <Col
                            key={i}
                            col={{
                                lg: 10,
                                xl: 8,
                            }}
                            offset={{
                                lg: 1,
                                xl: 2,
                            }}
                            pt={{
                                lg: 11,
                            }}
                            mb={
                                i !== pricingDetail.length - 1
                                    ? {
                                          xs: 15,
                                          lg: 0,
                                      }
                                    : {}
                            }
                            {...className(
                                `${allShown && activeTab !== i ? 'd-none' : ''}`
                            )}
                            data-a
                        >
                            <Heading
                                className={`h3 font-weight-bold d-lg-none mb-8 ${textStyle['child-underline']} ${textStyle['child-underline--tertiary']} ${style.headingMobile}`}
                                tag="h4"
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                            >
                                {`<u>${pricingItem.title}</u>`}
                            </Heading>
                            <div
                                data-sal="slide-up--lg-none"
                                data-sal-easing="ease-out-quart"
                            >
                                <Accordion
                                    key={i}
                                    items={pricingItem.items.map((item, i) => ({
                                        title: item.title,
                                        body: (
                                            <PricingTable
                                                key={i}
                                                extraClass={`mt-2 mt-lg-5 ${style.table}`}
                                                pricingTable={item.pricingTable}
                                            />
                                        ),
                                    }))}
                                    titleClassName={
                                        className(
                                            `h5 ${style['accordion-title']}`
                                        ).className
                                    }
                                    itemClassName={
                                        className(
                                            `mb-5 ${
                                                i === pricingDetail.length - 1
                                                    ? 'mb-lg-5'
                                                    : 'mb-lg-10'
                                            }`
                                        ).className
                                    }
                                    allShown={allShown}
                                    initialShow={null}
                                />
                            </div>
                            {button ? (
                                <div
                                    data-sal="slide-up"
                                    data-sal-easing="ease-out-quart"
                                    {...className('d-lg-none mt-8')}
                                >
                                    <ButtonComponent
                                        button={button}
                                        blockMobile={button.detached}
                                        buttonClassName={
                                            button.detached ? '' : style.button
                                        }
                                    />
                                </div>
                            ) : null}
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
}
